export default __webpack_public_path__ + "static/media/6.8c4b0659.png";